import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NetworkService } from '../shared/network.service';
@Injectable({
  providedIn: 'root'
})
export class AuthServiceLocal {
  private pageChange = new BehaviorSubject('false');
  currentPage = this.pageChange.asObservable();

  constructor(private networkService: NetworkService,
    ) { }

  Page(message: string) {
    this.pageChange.next(message)
  }
  validateLogin(req: any) {
    return this.networkService.post("api/auth/login", req, null, 'bearer');
  }
  SignupUser(req: any) {
    return this.networkService.post("api/users", req, null, null);
  }
  forgotPassword(req: any) {
    return this.networkService.post("api/auth/forgotPassword", req, null, 'bearer');
  }
  verifyEmail(body:any) {
    return this.networkService.post("api/users/verifyEmail",body, null,'bearer');
  }
  resetpassword(req: any) {
    return this.networkService.post("api/user/verify/password/forgot", req, null, null);
  }

  uploadPdf(image: any) {
    const formData = new FormData();
    formData.append("image",image);
    return this.networkService.uploadImages("api/s3upload/image-upload", formData, null, "bearer");
  }
  getFormDetailApiInvite(query:any) {
    return this.networkService.get("api/forms/invited"+query,null, null,'bearer');
  }
  submitMultipleTypeForm(body:any) {
    return this.networkService.postForm("api/forms/submit/invited/form/response",body, null,'bearer');
  }
  uploadImage(image: any) {
    const formData = new FormData();
    formData.append("file",image);
    return this.networkService.uploadImages("api/s3upload/media-upload", formData, null, "bearer");
  }
  getUserRole(query:any){
    return this.networkService.get("api/dropdowns/userRoles"+query,null, null,'bearer');
  }
  getPublicCircle(query:any){
    return this.networkService.get("api/circles/public/circles/names?"+query,null, null,'bearer');
  }
  validateToken(){
    return this.networkService.get("api/auth/verify/access/token",null, null,'bearer');
  }
 
}
